package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/** HUD keybinding 槽位管理器接口。 */
interface KeyBindingHost {
    // defaultKey / label 可空：.allin 允许省略（见 hud.md §1.5），省略 defaultKey 表示未绑定、label 表示无显示名。
    fun allocateSlot(bindingId: String, defaultKey: String?, label: String?, onTriggerBytes: ByteArray): String?
    fun releaseSlot(slotId: String)
    fun pollTriggers(slotIds: Collection<String>): List<ByteArray>

    companion object {
        @JvmField val NOOP: KeyBindingHost = object : KeyBindingHost {
            override fun allocateSlot(
                bindingId: String,
                defaultKey: String?,
                label: String?,
                onTriggerBytes: ByteArray,
            ): String? = null
            override fun releaseSlot(slotId: String) {}
            override fun pollTriggers(slotIds: Collection<String>): List<ByteArray> = emptyList()
        }
    }
}
